/*** IMPORTS FROM imports-loader ***/
var _ = require("lodash");

import jsonp from 'assets/js/jsonp'
import {
  commonParams,
  options,
  removePending,
  REQUEST_PREFIX
} from './config'
import axios from 'api/axios'
import Qs from 'qs'

const debug = process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'production_testing'

// 获取图片
export function getBanner(params) {
  var url = debug ? '/api/UICMS/GetIMGListByAPI' : `${REQUEST_PREFIX}/UICMS/GetIMGListByAPI`
  const data = Object.assign({}, {}, params)
  return axios({
    url: url,
    method: 'get',
    params: data
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}

// 点击率
export function IMGClick(params) {
  var url = debug ? '/api/UICMS/IMGClick' : `${REQUEST_PREFIX}/UICMS/IMGClick`
  const data = Object.assign({}, commonParams, params)
  return axios({
    url: url,
    method: 'post',
    data: data,
    transformRequest: [function (data) {
      return Qs.stringify(data)
    }]
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}

// cms 获取图片new
export function cmsBannerNew(params) {
  var url = debug ? '/api/UIBOM/MatPinterface' : `${REQUEST_PREFIX}/UIBOM/MatPinterface`
  const data = Object.assign({}, {}, params)
  return axios({
    url: url,
    method: 'post',
    params: data,
    transformRequest: [function (data) {
      console.log(Qs.stringify(data))
      return Qs.stringify(data);
    }]
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}

// cms 获取图片
export function cmsBanner(params) {
  var url = debug ? '/api/UIBOM/MatPinterface' : `${REQUEST_PREFIX}/UIBOM/MatPinterface`
  const data = Object.assign({}, {}, params)
  return axios({
    url: url,
    method: 'post',
    data: data,
    transformRequest: [function (data) {
      return Qs.stringify(data);
    }]
  }).then((res) => {
    return Promise.resolve(JSON.parse(res.data))
  }).catch(err => {
    return Promise.reject(err)
  })
}




// WEBPACK FOOTER //
// ./src/api/banner.js